import { storage } from '@/utils/storage';

const expMeth = {
  login(email = 'supportuser@opinew.com', password = 'password') {
    const postData = {
      email,
      password,
    };

    this.$http
      .post(`${process.env.VUE_APP_API_ENDPOINT}/api/support/auth`, postData)
      .then();
  },

  logout() {
    this.$http
      .post(`${process.env.VUE_APP_API_ENDPOINT}/api/support/logout`, {})
      .then();
  },

  synchroniseAllOrders(btnId) {
    this.snackText = 'All orders were synchronized correctly';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/synchronise-all-orders`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  synchroniseAllProducts(btnId) {
    this.snackText = 'All orders were synchronized correctly';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/synchronise-all-products`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
    });
  },

  changeTrial(btnId, date) {
    this.snackText = 'Trial end date was changed correctly';
    this.trialDialog = false;
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/change-trial`;
    const postData = { date: date };
    this.$http.post(url, postData).then((res) => {
      this.methodFinished(btnId);
    });
  },

  changeReviewImportQuota(btnId, importChange) {
    this.snackText = 'Review import quota was changed correctly';
    this.importDialog = false;
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/change-review-import-quota`;
    const postData = { quota: parseInt(importChange) };
    this.$http.post(url, postData).then((res) => {
      this.reviewImportQuo = res.data.reviewImportQuotaLeft;
      this.methodFinished(btnId);
      this.importChange = '';
    });
  },

  changeCreditsLeft(btnId, requestChange) {
    this.snackText = 'Credits were changed correctly';
    this.requestDialog = false;
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const quota = parseInt(requestChange);
    const url = `/api/support/${shopId}/change-credits-left`;
    const postData = { quota };
    this.$http.post(url, postData).then((res) => {
      this.creditsLeft = res.data.creditsLeft;
      this.methodFinished(btnId);
      this.requestChange = '';
    });
  },

  installShopCode(btnId) {
    this.snackText = 'Shop code was installed correctly';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const reinstall = true;
    const url = `/api/support/${shopId}/install-shop-code`;
    const postData = { reinstall, themeId: this.chosenTheme };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
    });
  },

  installLiquidSnippets(btnId) {
    this.snackText = 'Liquid snippets were installed correctly';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/install-liquid-snippets`;
    const postData = { themeId: this.chosenTheme };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
    });
  },

  uninstallShopCode(btnId) {
    this.snackText = 'Shop code was uninstalled correctly';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/uninstall-shop-code`;
    const postData = { themeId: this.chosenTheme };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
    });
  },

  listShopProducts() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/list-products`;
    this.$http.get(url).then((res) => {
      this.products = res.data;
    });
  },

  listShopProductsDetail(search, type) {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/list-products-detail?name=${search}`;
    this.$http.get(url).then((res) => {
      if (type == 'from') {
        this.productsDetailFrom = res.data;
      } else {
        this.productsDetailTo = res.data;
      }
    });
  },

  listShopProductImportEntries() {
    const shopId = this.currentStore;
    const productId = this.currentProduct;
    const url = `/api/support/${shopId}/list-product-import-entries/${productId}`;
    this.$http.get(url).then((res) => {
      this.importItems = res.data;
    });
  },

  updateShopProductMetafields(number) {
    this.methodsEnabled = false;
    this.snackText = 'Product metafields updated correctly';
    this.$emit('loadOn');
    const shopId = this.currentStore;
    const productId = number;
    const url = `/api/support/${shopId}/update-product-metafields/${productId}`;
    this.$http.post(url).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },

  synchroniseShopProductReviews(number) {
    this.methodsEnabled = false;
    this.snackText = 'Product reviews synchronized correctly';
    this.$emit('loadOn');
    const shopId = this.currentStore;
    const productId = number;
    const howManyReviews = 23;
    const postData = { howManyReviews };
    const url = `/api/support/${shopId}/synchronise-product-reviews/${productId}`;
    this.$http.post(url, postData).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },

  synchroniseShopProductImportEntryReviews(
    number,
    shopId = this.currentStore,
    productId = this.currentProduct,
    importEntryId = number,
    howManyReviews = 1,
    reviewStarSubset = null,
    translateReviews = null,
    importOnlyWithImages = null,
    importOnlyThisLanguage = null
  ) {
    this.methodsEnabled = false;
    this.snackText = 'Product import entry synchronized correctly';
    this.$emit('loadOn');
    const postData = {
      howManyReviews,
      reviewStarSubset,
      translateReviews,
      importOnlyWithImages,
      importOnlyThisLanguage,
    };
    const url = `/api/support/${shopId}/synchronise-product-reviews/${productId}/import-entry/${importEntryId}`;
    this.$http.post(url, postData).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },

  shopBrowse(tableShopId = null) {
    let shopId = '';

    if (tableShopId) {
      shopId = tableShopId;
    } else {
      shopId = this.currentStore;
    }

    const token = storage.getItem('OPW_TOKEN');
    const url = `${process.env.VUE_APP_API_ENDPOINT}/api/support/${shopId}/browse?jwt=${token}`;
    window.open(url, '_blank');
  },

  shopThemeEditor() {
    const shopId = this.currentStore;
    const token = storage.getItem('OPW_TOKEN');
    const themeId = this.chosenTheme
      ? this.chosenTheme
      : this.defaultMainTheme[0].id;
    const url = `${process.env.VUE_APP_API_ENDPOINT}/api/support/${shopId}/theme-editor?jwt=${token}&theme_id=${themeId}`;
    window.open(url, '_blank');
  },

  shopList() {
    const url = `/api/support/list-shops?name=${encodeURIComponent(
      this.searchTerm
    )}&order_by=${this.sortBy}&order_direction=${this.descendingValue ? 'desc' : 'asc'
      }&filter_by={"opinew_plan":[${this.chosenOpinewPlan}],"shopify_plan":"${this.chosenShopifyPlan
      }"}&start=${this.paginationStart}&length=${this.shopFetchCount}`;
    this.$http.get(url).then((res) => {
      this.shops = res.data.result;
      this.totalShopsCount = res.data.totalShops;
      this.shopsLoading = false;
    });
  },

  plansList() {
    const url = '/api/support/list-plans';
    this.$http.get(url).then((res) => {
      this.plans = res.data.sort(function (a, b) {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      });
    });
  },

  resyncAllMeta(btnId) {
    const shopId = this.currentStore;
    this.snackText = 'All metafields were resynchronised correctly';
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/synchronise-all-metafields`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
    });
  },

  refreshScriptTag(btnId) {
    const shopId = this.currentStore;
    this.snackText = 'Script Tag was refreshed correctly';
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/refresh_script_tag`;
    const postData = { themeId: this.chosenTheme };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
    });
  },

  allowPlanChange(btnId) {
    const shopId = this.currentStore;
    this.snackText = 'Shop is now able to change plan again';
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/allow-plan-change`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
    });
  },

  refreshGoogleFeed(btnId) {
    const shopId = this.currentStore;
    this.snackText = 'Google feed has been refreshed';
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/refresh-google-feed`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
    });
  },

  fetchEntriesDebounced() {
    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      this.shopList();
    }, 1500);
  },

  fetchProductsFromDebounced() {
    clearTimeout(this._timerId);
    const type = 'from';
    this._timerId = setTimeout(() => {
      this.listShopProductsDetail(this.searchProductFrom, type);
    }, 500);
  },
  fetchProductsToDebounced() {
    clearTimeout(this._timerId);
    const type = 'to';
    this._timerId = setTimeout(() => {
      this.listShopProductsDetail(this.searchProductTo, type);
    }, 500);
  },

  methodStart(btnId) {
    this.$emit('loadOn');
    this.methodsEnabled = false;
    this.btnStates[btnId].val = true;
  },

  methodFinished(btnId) {
    this.methodsEnabled = true;
    this.btnStates[btnId].val = false;
    this.snackState = true;
    this.$emit('loadOff');
  },

  shopChange() {
    this.reviewImportQuotaLeft = this.shop.reviewImportQuotaLeft;
    this.shopCreatedAt = new Date(this.shop.shopCreatedAt);
    this.planPrice = this.shop.planPrice;
    this.subscriptionDate = new Date(this.shop.subscriptionDate).toDateString();
    this.shopifyPlan = this.shop.shopifyPlan;
    this.influencedOrders = this.shop.influencedOrders;
    this.totalOrders = this.shop.totalOrders;
    this.photoReviews = this.shop.imageReviewsCount;
    this.videoReviews = this.shop.videoReviewsCount;
    this.featuredReviews = this.shop.featuredReviewsCount;
    this.reviewRequestCollection = this.shop.sendReviewRequests;
    this.opinewPlan = this.shop.activePlan;
    this.activeIntegrations = [
      { name: 'Gorgias', active: this.shop.integrationGorgiasActive },
      { name: 'Klaviyo', active: this.shop.integrationKlaviyoActive },
      { name: 'Limespot', active: this.shop.integrationLimespotActive },
      { name: 'Loyaltylion', active: this.shop.integrationLoyaltylionActive },
      { name: 'Omnisend', active: this.shop.integrationOmnisendActive },
      { name: 'Wiser', active: this.shop.integrationWiserActive },
      { name: 'Zendesk', active: this.shop.integrationZendeskActive },
    ];
    this.influencedRevenue = this.shop.influencedRevenue;
    this.reviewRequests = this.shop.reviewRequests;

    this.currentStore = this.shop.id;
    this.storeName = this.shop.name;
    this.billingOn = new Date(this.shop.billingOn).toDateString();
    this.trialEnd = new Date(this.shop.trialEndDate);
    this.trialCreation = new Date(this.shop.createdAt);

    this.creditsLeft = this.shop.creditsLeft;
    this.reviewImportQuo = this.shop.reviewImportQuota;
    this.reviewdOpinew = this.shop.shopLeftAppstoreReview;
    this.methodsEnabled = true;

    this.shopAPIKey = this.shop.apiKey;
    this.shopDomain = this.shop.domain;
    this.setMinDate();
    this.listShopProducts();
    this.listShopProductsDetail('', 'from');
    this.listShopProductsDetail('', 'to');
    this.fetchReferralOffers();
    this.fetchThemeStatus();
    this.listThemes();
    this.getAllPermissions();
    this.getShopsPermissions();
  },

  setMinDate() {
    const date1 = new Date(this.trialEnd);
    const year = date1.getUTCFullYear();
    let mm = date1.getUTCMonth() + 1;
    let dd = date1.getUTCDate();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    this.pickerStart = `${year}-${mm}`;
  },

  updateCurrentProduct(number) {
    this.currentProduct = number;
    this.listShopProductImportEntries();
  },

  showCodeViaHider(btnId) {
    this.snackText = 'Code is shown via hider';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/show-code-via-hider`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  hideCodeViaHider(btnId) {
    this.snackText = 'Code is hidden via hider';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/hide-code-via-hider`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },
  resetInstallation(btnId, themeId) {
    this.snackText = 'The installation process was reset';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/reset-widget-installation_status/${themeId}`;
    this.$http.post(url).then(() => {
      this.fetchThemeStatus();
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },
  fullProductStatsResync(btnId) {
    this.snackText = 'The stats for all products have been resynched';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/full-product-stats-resync`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },
  fullShopStatsResync(btnId) {
    this.snackText = 'The shop stats has been updated';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/full-shop-stats-resync`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },
  updateShopMetafields(btnId) {
    this.snackText = 'The shop metafields have been updated';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/update-shop-metafields`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  undeleteAllReviewsOneProduct(number) {
    this.methodsEnabled = false;
    this.snackText = 'All the reviews from product have been undeleted';
    this.$emit('loadOn');
    const shopId = this.currentStore;
    const productId = number;
    const url = `/api/support/${shopId}/undelete-all-reviews-one-product/${productId}`;
    this.$http.post(url).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },

  moveReviewsFrom(btnId, productFrom, productTo) {
    const postData = {
      productFrom,
      productTo,
    };
    this.moveReviewsDialog = false;
    this.snackText = 'The reviews have been moved';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/move-reviews-from-product`;
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  fetchReferralOffers() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/list-referral-offers`;
    this.$http.get(url).then((res) => {
      this.referralOffers = res.data;
    });
  },

  fetchThemeStatus() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/list-theme-status`;
    this.$http.get(url).then((res) => {
      this.themeStatus = res.data;
    });
  },

  assignDiscountToShop(btnId, referralSelection) {
    const postData = {
      referralSelection,
    };
    this.addReferralDialog = false;
    this.snackText = 'The discount has been linked to the shop';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/assign-discount-to-shop`;
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  resyncCrossShopLinkedProducts(btnId) {
    this.snackText = 'The products have been resynched';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/resync-only-cross-shop-linked-product`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  rewriteWalmartReviews(btnId) {
    this.snackText = 'Reviews have been rewritten';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/rewrite-reviews?uniqueness=${this.uniqueness}`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.$emit('loadOff');
    });
  },

  exportWalmartFeed(btnId) {
    this.snackText = 'Feed is being exported';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/export-walmart-feed`;
    this.$http.get(url).then((res) => {
      this.methodFinished(btnId);
      this.$emit('loadOff');

      const blob = new Blob([res.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'reviews.csv';
      link.click();
    });
  },

  listThemes() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/list-themes`;
    this.$http.get(url).then((res) => {
      this.chosenStoreThemes = res.data;
    });
  },

  refreshShopPermissions(btnId) {
    const shopId = this.currentStore;
    this.snackText = "The shop's permissions have been updated";
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/refresh-shop-permissions`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
    });
  },
  exportWalmartSampleFeed(btnId) {
    this.snackText = 'Sample Feed is being exported';
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/walmart-test-csv?uniqueness=${this.uniqueness}`;
    this.$http.get(url).then((res) => {
      this.methodFinished(btnId);
      this.$emit('loadOff');

      const blob = new Blob([res.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'walmart-sample.csv';
      link.click();
    });
  },
  getAllPermissions() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/all-permissions`;
    this.$http.get(url).then((res) => {
      this.allPermissions = res.data;
    });
  },
  getShopsPermissions() {
    const shopId = this.currentStore;
    const url = `/api/support/${shopId}/shop-permissions`;
    this.$http.get(url).then((res) => {
      this.selectedShopsPermissions = res.data;
    });
  },

  updatePermission(btnId) {
    this.snackText = 'The permission has been updated';
    this.requestDialog = false;
    this.methodStart(btnId);
    const shopId = this.currentStore;
    const permissionName = this.selectedPermission;
    const permissionValue = this.selectedPermissionValue;
    const url = `/api/support/${shopId}/update-shop-permission`;
    const postData = { permissionName: permissionName, value: permissionValue };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
      this.permissionsDialog = false;
    });
  },
  removeDuplicatedShopsReviews(number) {
    this.methodsEnabled = false;
    this.snackText = "Product's duplicated reviews have been deleted";
    this.$emit('loadOn');
    const shopId = this.currentStore;
    const productId = number;
    const url = `/api/support/${shopId}/delete-shop-duplicated-reviews`;
    const postData = { productId: productId };
    this.$http.post(url, postData).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },
  removeShopsDuplicatedReviews(btnId) {
    const shopId = this.currentStore;
    this.snackText = "The shop's duplicated reviews have been deleted";
    this.methodStart(btnId);
    const url = `/api/support/${shopId}/delete-shop-duplicated-reviews`;
    const postData = { productId: null };
    this.$http.post(url, postData).then(() => {
      this.methodFinished(btnId);
    });
  },

  processWalmartSkuMappingFile() {
    const shopId = this.currentStore;
    this.snackText = 'The walmart csv file has been processed';
    const data = new FormData();
    data.append('csv', this.file);
    const url = `/api/support/${shopId}/process-walmart-sku-mapping-file`;
    this.$http.post(url, data).then((res) => {
      this.snackState = true;
    });
  },
  getReviewExamples() {
    this.examplesDialog = true;
    this.reviewLoading = true;
    const url = '/api/support/example-reviews';
    this.$http.get(url).then((res) => {
      this.parsedExamples = '';
      res.data.forEach((element) => {
        this.parsedExamples =
          this.parsedExamples +
          `
${element}`;
      });
      this.reviewLoading = false;
    });
  },
  copyWidgetCode() {
    this.$refs.reviewText.$refs.input.select();
    document.execCommand('copy');
  },

  removeOpinewBranding(btnId) {
    this.methodStart(btnId);
    const shopId = this.currentStore;
    this.snackText = 'The Opinew branding has been removed';
    const url = `/api/support/${shopId}/remove-branding`;
    this.$http.post(url).then(() => {
      this.methodFinished(btnId);
      this.snackState = true;
    });
  },

  removeScriptTag(btnId) {
    this.methodStart(btnId);
    const shopId = this.currentStore;
    this.snackText = 'The script tag has been removed';
    const url = `/api/support/${shopId}/remove-script-tags`;
    this.$http.post(url, { themeId: this.chosenTheme }).then(() => {
      this.methodFinished(btnId);
      this.snackState = true;
    });
  },

  createCustomDiscount(btnId) {
    this.methodStart(btnId);
    const shopId = this.currentStore ? this.currentStore : null;
    const bodyData = {
      planIds: this.discountPlans,
      discountAmount: this.discountAmount,
      trialDays: this.trialDaysAmount,
      discountMonthPeriod: this.discounMonthPeriod,
      expiryDate: this.newDiscountExpiryDate,
      shopId: shopId,
    };
    this.snackText = 'The new discount code has been created. ';
    const url = '/api/support/create-custom-discount';
    this.$http.post(url, bodyData).then((res) => {
      this.methodFinished(btnId);
      this.snackState = true;
      this.lastCreatedDiscount = res.data.discountCode;
      this.lastCreatedDiscountDate = new Date().toLocaleString();
      this.lastDiscountChosenPlans = this.chosenOpinewPlanDiscount;
      this.lastDiscountAmount = this.discountAmount;
      this.lastDiscountDaysTrial = this.trialDaysAmount;
      this.lastDiscountExpiryDate = this.newDiscountExpiryDate;
      this.lastDiscountMonthPeriod = this.discounMonthPeriod;
      this.$refs.discountform.reset();
    });
  },
  fetchLastFiveDiscounts() {
    const url = '/api/support/last-five-discounts';
    this.$http.get(url).then((res) => {
      this.lastFiveCoupons = res.data;
    });
  },

  createThreeMonthDiscount(btnId) {
    this.methodStart(btnId);
    const bodyData = {
      planIds: this.chosenOpinewPlanThreeMonthDiscount,
      discountAmount: this.discountAmountThreeMonths,
      trialDays: this.trialDaysAmountThreeMonths,
    };
    const shopId = this.currentStore;
    this.snackText = 'The new 3 month discount code has been created. ';
    const url = `/api/support/${shopId}/create-three-month-discount`;
    this.$http.post(url, bodyData).then((res) => {
      this.methodFinished(btnId);
      this.snackState = true;
      this.lastCreatedDiscount = res.data.discountCode;
      this.lastCreatedDiscountDate = new Date().toLocaleString();
      this.$refs.threeMonthDiscountForm.reset();
    });
  },

  publishAllReviewsOneProduct(number) {
    this.methodsEnabled = false;
    this.snackText = 'All the reviews of this product have been published';
    this.$emit('loadOn');
    const shopId = this.currentStore;
    const productId = number;
    const url = `/api/support/${shopId}/publish-all-reviews-one-product/${productId}`;
    this.$http.post(url).then(() => {
      this.snackState = true;
      this.$emit('loadOff');
      this.methodsEnabled = true;
    });
  },

  unstuckImportEntries(btnId) {
    this.methodStart(btnId);
    const bodyData = {};
    const shopId = this.currentStore;
    this.snackText = "The shop's import entries have been reset";
    const url = `/api/support/${shopId}/unstuck-import-entries`;
    this.$http.post(url, bodyData).then(() => {
      this.methodFinished(btnId);
      this.snackState = true;
    });
  },

  resetOnboarding(btnId) {
    this.methodStart(btnId);
    const bodyData = {};
    const shopId = this.currentStore;
    this.snackText = "The shop's onboarding progress has been reset";
    const url = `/api/support/${shopId}/install-onboarding-reset`;
    this.$http.post(url, bodyData).then(() => {
      this.methodFinished(btnId);
      this.snackState = true;
    });
  },

  enableEnterpriseUpgradeButton(btnId) {
    this.methodStart(btnId);
    const bodyData = {};
    const shopId = this.currentStore;
    this.snackText = "The shop's enterprise plan button is now showing";
    const url = `/api/support/${shopId}/enable-enterprise-upgrade-button`;
    this.$http.post(url, bodyData).then(() => {
      this.methodFinished(btnId);
      this.snackState = true;
    });
  },

  generatePaulTable() {
    this.result = '';
    this.paulShops = [];
    this.paulTotalShopsCount = 0;
    const url = `/api/support/generate-paul-table?name=${this.paulSearch}&opinew_plan=[${this.chosenOpinewPlan}]&shopify_plan=[${this.chosenShopifyPlan}]&mrr_option=${this.chosenMrrOption}&mrr_value=${this.mrrValue}&integrations=${this.filteredIntegration}&price_option=${this.chosenPriceOption}&price=${this.chosenPrice}`;
    this.$http.get(url).then((res) => {
      this.result = res.data;
      this.paulShops = res.data.result;
      this.paulTotalShopsCount = res.data.totalShops;
    });
  },

  showPaulTableEntry(itemId) {
    this.snackText = 'Retrieving details';
    const shopId = this.currentStore;
    const url = `/api/support/shops/${itemId}/show-paul-table-entry`;
    this.$http.get(url).then((res) => {
      this.shopDetails = true;
      this.paulSelected = res.data;
    });
  },

  deleteFilter() {
    const url = `/api/support/delete-filter?filter_name=${this.filterName}`;
    this.$http.post(url).then((res) => { });
  },

  getFilters() {
    const url = '/api/support/get-filters';
    this.$http.get(url).then((res) => {
      this.savedFilters = res.data;
    });
  },

  saveFilter() {
    const url = `/api/support/save-filter?filter_name=${this.filterName}&name=${this.paulSearch}&opinew_plan=[${this.chosenOpinewPlan}]&shopify_plan=[${this.chosenShopifyPlan}]&mrr_option=${this.chosenMrrOption}&mrr_value=${this.mrrValue}&integrations=${this.filteredIntegration}&price_option=${this.chosenPriceOption}&price=${this.chosenPrice}`;
    this.shopDetails = false;
    this.$http.post(url).then((res) => { });
  },

  loadFilter() {
    const url = `/api/support/load-filter?filter_name=${this.filter}`;
    this.$http.get(url).then((res) => {
      this.result = res.data;
      this.paulShops = res.data.result;
      this.paulTotalShopsCount = res.data.totalShops;
    });
    this.paulSearch == this.filter.name;
  },

  createWorkingGroup() {
    const url = `/api/support/create-working-group?name=${this.workingGroupName}&description=${this.workingGroupDescription}`;
    this.$http.post(url).then((res) => { });
  },

  loadWorkingGroups() {
    const url = '/api/support/load-working-groups';
    this.$http.get(url).then((res) => {
      this.workingGroups = res.data;
    });
  },

  getWorkingGroup() {
    const url = `/api/support/working-groups/${this.chosenworkingGroup}/get-working-group`;
    this.$http.get(url).then((res) => {
      this.paulShops = res.data.result;
      this.paulTotalShopsCount = res.data.totalShops;
    });
  },

  getWorkingGroupId() { },

  addToWorkingGroup(itemId) {
    const url = `/api/support/working-groups/${this.chosenworkingGroup}/add-to-working-group/${itemId}`;
    this.$http.post(url).then((res) => {
      this.paulShops = res.data.result;
      this.paulTotalShopsCount = res.data.totalShops;
    });
  },

  deleteFromWorkingGroup(itemId) {
    const url = `/api/support/working-groups/${this.chosenworkingGroup}/delete-from-working-group/${itemId}`;
    this.$http.post(url).then((res) => {
      this.paulShops = res.data.result;
      this.paulTotalShopsCount = res.data.totalShops;
    });
  },
};
export default expMeth;
